<div #galleryToolbar class="lightbox-gallery-toolbar">
  <div #loader class="lightbox-gallery-loader" style="opacity: 0">
    <div class="spinner-grow text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="this.lightboxItems.length > 1" class="lightbox-gallery-left-tools">
    <p class="lightbox-gallery-counter">{{ index + 1 }} / {{ lightboxItems.length }}</p>
  </div>
  <div class="lightbox-gallery-right-tools">
    <button
      type="button"
      #btnFullsreen
      class="lightbox-gallery-button lightbox-gallery-fullscreen-btn"
      [ngClass]="{ 'fontawesome-pro': lightbox.fontAwesome === 'pro' }"
      aria-label="Toggle fullscreen"
      (click)="toggleFullscreen()"
    ></button>
    <button
      type="button"
      #btnZoom
      class="lightbox-gallery-button lightbox-gallery-zoom-btn"
      [ngClass]="{ 'fontawesome-pro': lightbox.fontAwesome === 'pro' }"
      aria-label="Zoom in"
      (click)="toggleZoom()"
    ></button>
    <button
      type="button"
      class="lightbox-gallery-button lightbox-gallery-close-btn"
      [ngClass]="{ 'fontawesome-pro': lightbox.fontAwesome === 'pro' }"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>
</div>

<div class="lightbox-gallery-content">
  <ng-container *ngFor="let item of [].constructor(3); let index = index">
    <div 
      #imageWrapper
      class="lightbox-gallery-image"
      [ngStyle]="{'opacity': activeModalImageIndex === index ? '1' : '0'}"
    >
      <img
        #image
        draggable="false"
        @fade
        (load)="load(index)"
        (mousedown)="onMousedown($event)"
        (mouseup)="onMouseup($event)"
        (mousemove)="onMousemove($event)"
        (swipeleft)="slide('right')"
        (swiperight)="slide('left')"
        (wheel)="onWheel($event)"
        (touchmove)="onTouchMove($event.touches)"
        (touchstart)="onTouchStart($event.touches)"

      />
    </div>
  </ng-container>
</div>

<div *ngIf="lightboxItems.length > 1" #leftArrow class="lightbox-gallery-arrow-left" style="opacity: 1">
  <button
    type="button"
    #btnPrevious
    aria-label="Previous"
    (click)="slide('left')"
    class="lightbox-gallery-button"
    [ngClass]="{ 'fontawesome-pro': lightbox.fontAwesome === 'pro' }"
  ></button>
</div>
<div *ngIf="lightboxItems.length > 1" #rightArrow class="lightbox-gallery-arrow-right" style="opacity: 1">
  <button
    type="button"
    #btnNext
    aria-label="Next"
    (click)="slide('right')"
    class="lightbox-gallery-button"
    [ngClass]="{ 'fontawesome-pro': lightbox.fontAwesome === 'pro' }"
  ></button>
</div>
<div class="lightbox-gallery-caption-wrapper">
  <p class="lightbox-gallery-caption">
    {{ activeLightboxItem.caption || activeLightboxItem.el.nativeElement.alt }}
  </p>
</div>
